const producerFilterUIConfig = {
  uiScheme: {
    "ui:classNames": "filters-container",

    search: {
      "ui:options": {
        label: false, // Oculta el título del campo
        placeholder: "Buscar...",
      },
    },
    status: {
      "ui:options": {
        label: false,
      },
    },
  },
};

const getProducerFilterUIConfig: any = () => {
  return producerFilterUIConfig;
};

export default getProducerFilterUIConfig;
